import { __rest, __assign } from 'tslib';
import { Avatar as Avatar$1 } from '@material-ui/core';
import { User } from '@popmenu/web-icons';
import React, { forwardRef } from 'react';
import { Icon } from '../Icon/Icon.js';
import { useAvatarStyles } from './avatar.styles.js';
import { useImgProps } from './util/useImageProps.js';

var Avatar = forwardRef(function (props, ref) {
    var children = props.children, src = props.src, alt = props.alt, fallback = props.fallback, muiProps = __rest(props, ["children", "src", "alt", "fallback"]);
    var _a = useImgProps(props), imgProps = _a.imgProps, loaded = _a.loaded;
    var classes = useAvatarStyles(__assign(__assign({}, props), { loaded: loaded }));
    var displayAltTextFallback = src && alt;
    var displayNoFallback = fallback === 'none';
    var displayCustomFallback = fallback !== 'none' && typeof fallback !== 'undefined';
    var Fallback;
    if (displayAltTextFallback) {
        Fallback = null;
    }
    else if (displayNoFallback) {
        Fallback = ' ';
    }
    else if (displayCustomFallback) {
        Fallback = fallback;
    }
    else {
        Fallback = React.createElement(Icon, { icon: User, className: classes.fallback });
    }
    return (React.createElement(Avatar$1, __assign({ ref: ref, classes: { root: classes.root }, src: src, alt: alt }, muiProps, { imgProps: imgProps }), children || Fallback));
});
Avatar.defaultProps = {
    size: 'medium',
    fit: 'cover',
    background: '#E0E0E0',
};
Avatar.displayName = 'Avatar';

export { Avatar };
//# sourceMappingURL=Avatar.js.map
